<template>
	<div class="mx-auto" style="max-width: 600px;">
		<v-stepper v-model="currentStep">
			<v-stepper-header>
				<v-stepper-step step="1" @click="currentStep = 1"
					>Dati di fatturazione</v-stepper-step
				>
				<v-divider></v-divider>
				<v-stepper-step
					step="2"
					@click="billingProfile ? (currentStep = 2) : ''"
					>Termini e Condizioni</v-stepper-step
				>
				<v-divider></v-divider>
				<v-stepper-step
					step="3"
					@click="
						billingProfile && !PrivacyRequired
							? (currentStep = 3)
							: ''
					"
					>Pagamento</v-stepper-step
				>
			</v-stepper-header>
			<v-stepper-items>
				<v-stepper-content step="1">
					<v-card v-if="billingProfile">
						<v-card-text>
							<div class="py-4">
								<h3
									class="text-center poppins-semibold"
									style="font-size: 1.2rem"
								>
									Dati di Fatturazione
								</h3>
							</div>
							<div class="mb-3 text--primary poppins-regular">
								<div class="d-flex mb-2">
									<span class="font-weight-bold label-fixed-width">{{ $t("common.name") }}:</span>
									<span>{{ billingProfile.RagioneSociale }}</span>
								</div>
								<div class="d-flex mb-2">
									<span class="font-weight-bold label-fixed-width">{{ $t("common.fiscalCode") }}:</span>
									<span class="text-uppercase">{{ billingProfile.CodiceFiscale }}</span>
								</div>
								<div v-if="billingProfile.PartitaIva" class="d-flex">
									<span class="font-weight-bold label-fixed-width">{{ $t("common.pIva") }}:</span>
									<span>{{ billingProfile.PartitaIva }}</span>
								</div>
								<div class="d-flex mb-2">
									<span class="font-weight-bold label-fixed-width">{{ $t("common.address") }}:</span>
									<span>
            {{ billingProfile.Address }} <br />
            {{ billingProfile.PostalCode }}
            {{ billingProfile.Comune.Name }} ({{
											billingProfile.Comune.ProvinciaAbbreviation
										}})
        </span>
								</div>
							</div>

						</v-card-text>
						<v-card-actions>
							<v-btn
								@click="currentStep = 2"
								block large
								class="primary text-capitalize"
								>{{ $t("common.proceed") }}</v-btn
							>
						</v-card-actions>
					</v-card>
					<AddEditBillingProfileCard
						v-else
						v-model="showAddBillingProfile"
						:mode="1"
						@updated="OnBillingProfileUpdated"
						Header="Mancano i dati per la fattura"
					>
					</AddEditBillingProfileCard>
				</v-stepper-content>
				<v-stepper-content step="2">
					<PrivacyContractsCard
						@contractsAccepted="OnPrivacyContractAccepted"
						:previouslyAccepted="PrivacySigned"
					></PrivacyContractsCard>
				</v-stepper-content>
				<v-stepper-content step="3">
					<v-card v-if="billingProfile">
						<v-card-text>
							<div class="py-4">
								<h3
									class="text-center poppins-semibold"
									style="font-size: 1.2rem"
								>
									Pagamento
								</h3>
							</div>
							<StripePaymentMethods></StripePaymentMethods>
						</v-card-text>
					</v-card>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>

	</div>
</template>
<script>
import CrudClient from "@/services/CrudClient";
import PrivacyContractsCard from "@/views/Patients/components/PrivacyContractsCard.vue";
import AddEditBillingProfileCard from "@/components/Account/AddEditBillingProfileCard.vue";
import StripePaymentMethods from "@/views/Patients/components/StripePaymentMethods.vue";
import { cu } from "@fullcalendar/core/internal-common";

export default {
	name: "Checkout.vue",
	components: {
		StripePaymentMethods,
		AddEditBillingProfileCard,
		PrivacyContractsCard
	},
	data() {
		return {
			showAddBillingProfile: false,
			showPrivacyContracts: false,
			billingProfile: null,
			currentStep: 1,
			patientDetails: null,
			nutritionistBillingProfileStatus: null
		};
	},
	computed: {
		PrivacySigned() {
			return this.patientDetails?.PrivacyContractSigned;
		},
		PrivacyRequired() {
			return (
				this.nutritionistBillingProfileStatus
					?.IsBillingProfileComplete &&
				this.patientDetails?.PrivacyContractSigned === false
			);
		}
	},
	created() {
		this.BillingProfilesSelfService = new CrudClient(
			"User/BillingProfilesSelf"
		);
		this.CurrentPatientProfileService = new CrudClient(
			"CurrentPatient/Profile"
		);

		this.CurrentPatientNutritionistService = new CrudClient(
			"CurrentPatient/Nutritionist"
		);
	},
	async mounted() {
		await this.LoadBillingProfile();

		this.patientDetails = await this.CurrentPatientProfileService.GetSelectedFields(
			null,
			"PrivacyContractSigned"
		);

		if (!this.billingProfile) {
			return;
		}

		// check if Nutritionist Billing Profile is complete
		this.nutritionistBillingProfileStatus = await this.CurrentPatientNutritionistService.Get(
			null,
			"IsBillingProfileComplete"
		);

		if (this.PrivacyRequired) {
			// this.$emit("RequirePrivacyContract");
			this.showPrivacyContracts = true;
		}
	},
	methods: {
		cu,

		async LoadBillingProfile() {
			const res = await this.BillingProfilesSelfService.GetPaged({
				limit: 1,
				skip: 0,
				fields: "*, Comune.Name, Comune.ProvinciaAbbreviation",
				filter: "IsActive:true",
				addApplicationId: true
			});

			if (res.Data.length === 0) {
				this.$emit("RequireBillingProfile");
				this.showAddBillingProfile = true;
				return;
			}

			this.billingProfile = res.Data[0];
		},
		async OnBillingProfileUpdated() {
			this.showAddBillingProfile = false;

			await this.LoadBillingProfile();

			this.currentStep = 2;
		},
		OnPrivacyContractAccepted() {
			// this.$refs.stripeButton.redirectToStripe();
			this.currentStep = 3;
		}
	}
};
</script>

<style scoped lang="scss">

.label-fixed-width {
	min-width: 120px; /* Adjust this value to fit your longest label */
	display: inline-block;
}

</style>
